module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pvMethod":"Auslegung","pvMethodAuto":"Automatische Auslegung mit GIS-Daten","pvMethodManual":"Manuelle Auslegung","costsAuto":"Automatische Kostenschätzung","costsLabel":"Kosten","subsidiesLabel":"Subventionen"}}')
  delete Component.options._Ctor
}
